<div *ngIf="isLoading">Loading Status List...</div>

<select (change)="optionChanged.emit(true)" *ngIf="!isLoading" [(ngModel)]="model.creditorStatus" [compareWith]="byId"
        [required]="required"
        class="form-control" name="status">
    <option *ngFor="let singleStatus of statuses" [ngValue]="singleStatus">{{ singleStatus.name }}</option>
</select>
